export const ISSUE_ACTIVITY_TYPES = {
  created: 'issue-created',
  stateChanged: 'issue-state-changed',
  assignmentChanged: 'issue-assignment-changed',
  updated: 'issue-updated',
  deleted: 'issue-deleted',
} as const;

export const TASK_ACTIVITY_TYPES = {
  created: 'task-created',
  stateChanged: 'task-state-changed',
  inputRequested: 'task-input-requested',
  updated: 'task-updated',
  deleted: 'task-deleted',
} as const;

export type IssueActivityTypeId =
  (typeof ISSUE_ACTIVITY_TYPES)[keyof typeof ISSUE_ACTIVITY_TYPES];

export type TaskActivityTypeId =
  (typeof TASK_ACTIVITY_TYPES)[keyof typeof TASK_ACTIVITY_TYPES];
